import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;

    .content-container {
        .headline {
            font-size: 1.7em;
            margin-bottom: 3em;
            font-weight: 700;
            color: #262626;
            text-align: center;
        }

        .list-simple {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            flex-wrap: wrap;
            gap: 3.5em;
            margin: auto;

            &__item {
                position: relative;
                max-width: 400px;
                display: flex;
                flex-direction: column;
                gap: 1em;
                min-height: 9em;
                flex: 1 1 300px;

                .bg {
                    position: absolute;
                    width: 140px;
                    height: 140px;
                    border-radius: 100px;
                    background-color: #efe6dd;
                    z-index: -1;
                    left: -50px;
                    top: -30px;
                }

                &:nth-of-type(even) {
                    .bg {
                        background-color: #dfd1c4;
                    }
                }

                &-title {
                    font-weight: bold;
                }

                &-subtitle {
                    ul,
                    ol {
                        padding: 0;
                        margin: 0;

                        li {
                            margin-left: 1em;
                        }

                        li,
                        li > span {
                            background-color: transparent !important;
                            text-align: left;
                            font-size: 1em !important;
                        }
                    }

                    ul {
                        li {
                            &::marker {
                                color: #BA9449;
                                font-size: 1.4em;
                            }
                        }
                    }

                    ol {
                        li {
                            &::marker {
                                color: #BA9449;
                                font-size: 1em;
                            }
                        }
                    }

                    p {
                        font-size: 1em !important;

                        span {
                            font-size: inherit !important;
                        }
                    }
                }
            }
        }
    }

    @media all and (max-width: ${variables.tabletS}) {
        .content-container {
            .list-simple {
                flex-direction: column;
                justify-content: flex-start;
                max-width: fit-content;

                &__item {
                    flex: 1 1 100%;
                    min-height: 8em;

                    .bg {
                        width: 100px;
                        height: 100px;
                        left: -30px;
                        top: -20px;
                    }
                }
            }
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        .content-container {
            .list-simple {
                padding-left: 2em;
            }
        }
    }
`;
